import { PromptParameter } from './promptParser';

/**
 * Generate an Adaptive Card JSON for collecting parameter values
 * @param parameters Array of parameters to collect
 * @param promptTitle Title of the prompt (used in card header)
 * @returns JSON string for the Adaptive Card
 */
export function generateParameterCollectionCard(
  parameters: PromptParameter[],
  promptTitle: string
): string {
  const card = {
    type: 'AdaptiveCard',
    version: '1.5',
    body: [
      {
        type: 'TextBlock',
        text: promptTitle,
        weight: 'Bolder',
        size: 'Medium',
        wrap: true,
      },
      {
        type: 'TextBlock',
        text: 'Please provide the following information:',
        wrap: true,
        spacing: 'Small',
      },
      ...parameters.map((param) => ({
        type: 'Input.Text',
        id: param.name,
        label: param.displayName,
        placeholder: param.placeholder,
        isRequired: true,
        errorMessage: `${param.displayName} is required`,
      })),
    ],
    actions: [
      {
        type: 'Action.Submit',
        title: 'Submit',
        data: {
          action: 'submitParameters',
        },
      },
    ],
  };

  return JSON.stringify(card);
}
